import Swiper from 'swiper';
import { Manipulation, Navigation, Pagination, Zoom, Thumbs } from 'swiper/modules'

export default function setGallery(Product) {
  // Define o breakpoint que desabilita o zoom utilizando a tag mobile
  const correctedBreakpoint = window.innerWidth + 1;
  let zoomBreakpoint = window.mobile ? correctedBreakpoint : 992;

  let thumbs = null;
  const thumbsModules = Product.thumbsSlider.element ? [Manipulation] : [];
  
  if (Product.thumbsSlider.element) {
    thumbs = new Swiper(Product.thumbsSlider.element, {
      modules: thumbsModules,
      direction: 'horizontal',
      slidesPerView: 7,
      spaceBetween: 8,
      speed: 1000,
      watchSlidesProgress: true,
      watchOverflow: true,
      preloadImages: false,
      lazy: {
        checkInView: true,
        loadOnTransitionStart: true,
        loadPrevNext: false
      }
    });
  }

  const mainModules = [Manipulation, Navigation, Zoom];
  if (thumbs) {
    mainModules.push(Thumbs);
  }

  const mainConfig = {
    modules: mainModules,
    slidesPerView: 1,
    speed: 1000,
    watchOverflow: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '[data-main-slider] .swiper-button-next',
      prevEl: '[data-main-slider] .swiper-button-prev',
    },
    pagination: {
      el: '[data-product-images] .swiper-pagination',
      clickable: true,
      type: 'bullets'
    },
    preloadImages: false,
    lazy: {
      checkInView: true,
      loadOnTransitionStart: true
    },
    zoom: {
      maxRatio: 1.5,
      zoomedSlideClass: '-zoomed'
    },
    breakpoints: {
      [zoomBreakpoint]: {
        zoom: false,
      }
    }
  };

  if (thumbs) {
    mainConfig.thumbs = {
      swiper: thumbs,
    };
  }

  const main = new Swiper(Product.mainSlider.element, mainConfig);

  Product.thumbsSlider.swiper = thumbs;
  Product.mainSlider.swiper = main;
}
